export const FILE_UPLOAD_STATUS = {
  IDLE: 'idle',
  DRAG_ACTIVE: 'dragActive',
  ACCEPTED: 'accepted',
  ERROR: 'error',
};

export const DEFAULT_MAX_FILE_SIZE_MB = 10;
export const BYTES_PER_MB = 1024 * 1024;
